<template>
    <svg
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Logo"
            clip-path="url(#clip0_104_13765)"
        >
            <path
                id="Vector"
                d="M16.0638 19.9855L11.5916 15.7367C10.2223 14.3674 7.9929 14.3674 6.62355 15.7367L6.59228 15.768L2.30777 19.8291L0.00244141 17.3965L4.27132 13.3488C6.94299 10.6949 11.2722 10.6949 13.9439 13.3488L18.3713 17.5528L16.0638 19.9833V19.9855Z"
                fill="#040F0F"
            />
            <path
                id="Vector_2"
                d="M9.26375 9.06C7.4387 9.06 5.72088 8.35187 4.42748 7.06518L0 2.86109L2.30756 0.430664L6.77972 4.67943C7.44317 5.34289 8.32554 5.70924 9.26375 5.70924C10.202 5.70924 11.0843 5.34289 11.7478 4.67943L11.7791 4.64816L16.0636 0.587033L18.3689 3.01969L14.1 7.06518C12.8066 8.35187 11.0888 9.05777 9.26375 9.05777V9.06Z"
                fill="#040F0F"
            />
        </g>
        <defs>
            <clipPath id="clip0_104_13765">
                <rect
                    width="18.4615"
                    height="20"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
</template>
